export default {
  colorItem: {
    single: '単色',
    gradient: 'グラデーション',
  },
  alignment: {
    ar: 'アラビア語では両端揃えはサポートされていません',
    my: 'ミャンマー語では両端揃えはサポートされていません',
  },
  textNode: {
    title: 'テキストの整列方法',
  },
  textStyleShadow: {
    shadowBlur: 'ぼかし',
    title: 'シャドウ',
  },
  textStyleSize: {
    fontSize: 'フォントサイズ',
    letterSpacing: '文字間隔',
    lineHeight: '行の高さ',
    bold: '太字',
    italic: 'イタリック',
    underline: '下線',
    strikethrough: '取り消し線',
  },
  textStyleStroke: {
    title: '輪郭',
  },
  textStyle: {
    applyToOtherLanguage: '他の言語に適用',
    languageMessage: [
      '他の言語なし',
      '他の言語へのスタイルの適用に成功しました',
    ],
  },
}
